import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Form, message } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Container } from '$app/shared/components/Container';
import { getGarageById, putGarageById } from './actions';
import Menu from '../components/Menu';
import GaragePageHeader from '../components/GaragePageHeader';
import MakeCapacityForm from './form';
import CapacityTable from './capacityTable';
import Loading from '$app/shared/components/Loading';

const mapPropsToFields = (props) => {
  const { initialValue } = props;
  if (!initialValue) return;
  const keys = Object.keys(initialValue);
  return keys.reduce((ac, val) => {
    ac[val] = Form.createFormField({
      value: initialValue[val],
    });
    return ac;
  }, {});
};

const CapacityForm = MakeCapacityForm(mapPropsToFields);
const timeFormat = 'HH:mm:ss';

function GarageCapacityPage({ history, match }) {
  const garageId = match.params.garageId;
  const [garage, setGarage] = useState(null);
  const getGarage = async () => {
    const garageData = await getGarageById(garageId);
    const formattedGarageValues = Object.entries(garageData).map((field) => {
      const key = field[0];
      const value = field[1];
      if (key.includes('Hour')) {
        return [key, moment(value, timeFormat)];
      }
      return field;
    });
    setGarage(Object.fromEntries(formattedGarageValues));
  };

  useEffect(() => {
    if (!garage) getGarage();
  }, [garage]);

  const mapUpdatedData = (data) => {
    const mappedData = {};
    Object.entries(data).forEach(([key]) => {
      if (key === 'deliveryOptions') {
        mappedData.garageDeliveryOption = data.deliveryOptions[0].deliveryOption;
      } else if (garage[key] !== 'undefined') {
        if (key.includes('Hour')) {
          mappedData[key] = moment(data[key], timeFormat);
        } else {
          mappedData[key] = data[key];
        }
      }
    });
    return mappedData;
  };

  const onSubmit = (e, form) => {
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const data = {
          ...values,
          businessName: garage.businessName,
          email: garage.email,
          openingHour: moment(values.openingHour, timeFormat).format(timeFormat),
          closingHour: moment(values.closingHour, timeFormat).format(timeFormat),
          timetableId: garage.timetableId,
          segment: garage.segment,
        };
        return message
          .loading(`Saving garage...`, 1)
          .then(() => putGarageById(garageId, data))
          .then(({ data: updatedGarage }) => {
            setGarage(mapUpdatedData(updatedGarage));
            window.location.reload();
            return message.info(`garage updated`, 1);
          });
      }
      return message.error(`Please correct the errors and try again.`);
    });
  };

  if (!garage) return <Loading />;

  return (
    <Container>
      <GaragePageHeader history={history} name={garage?.businessName} />

      <Menu selectedItem="capacity" garageId={garageId} history={history} />

      <CapacityForm initialValue={garage} onSubmit={onSubmit} />

      <CapacityTable garage={garage} getGarage={getGarage} />
    </Container>
  );
}

GarageCapacityPage.propTypes = {
  history: PropTypes.any.isRequired,
  match: PropTypes.any.isRequired,
};

export default withRouter(GarageCapacityPage);
